<template>
  <div />
</template>

<script>
export default {
  name: 'TicketAttachments',
}
</script>
